// extracted by mini-css-extract-plugin
module.exports = {"rating":"GoogleMapPlaceRating_rating__1-kV9","stars":"GoogleMapPlaceRating_stars__oeFK3","star":"GoogleMapPlaceRating_star__bQWns"};